import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { dateOptionsCriteria, footfallTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_DAILY_AVERAGES,
  FETCH_DAILY_AVERAGES_ERROR,
  SET_DAILY_AVERAGES,
} from '../../constants';


const insightsDailyAverages = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_DAILY_AVERAGES),
    switchMap(() =>
      ajax({
        url: `${
          state$.value.auth.server
          }/report/daily-averages?${
            footfallTabCriteria(state$)
          }${
            boundariesCriteria(state$)
          }${
            dateOptionsCriteria(state$, 'footfall')
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_DAILY_AVERAGES,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_DAILY_AVERAGES_ERROR,
            error,
          })
        )
      )
    )
  );

export default insightsDailyAverages;
